<h2 mat-dialog-title>{{ file?.name }}</h2>
<mat-dialog-content>
    <img [src]="safeData" alt="" />
</mat-dialog-content>
